// File: pages/GrazeBoxes/GrazeBoxDetails/TitleAndDescription.jsx
import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const TitleAndDescription = ({ name, reviewCount, shortDescription }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
        {name}
      </Typography>

      {/* Star Rating and Review Count */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <StarIcon sx={{ color: "#FFD700", mr: 0.5 }} />
        <Typography sx={{ color: "gray" }}>
          5.0 ({reviewCount} reviews)
        </Typography>
      </Box>

      {/* Short Description */}
      <Typography variant="body1" sx={{ color: "gray", mb: 2 }}>
        {shortDescription}
      </Typography>

      {/* Availability */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <LocalShippingIcon sx={{ color: "green", mr: 1 }} />
        <Typography color="green">Local Delivery Available</Typography>
      </Box>

      <Divider />
    </Box>
  );
};

export default TitleAndDescription;
